export default __webpack_public_path__ + "static/media/s6.9904f0b0.png";